import { LayoutDashboard, BookOpen, Video, Monitor, Clock, Library, Award, CheckSquare, Calendar, Shirt, Bell, UserCircle } from 'lucide-react';
import type { NavItem } from '@/components/layout/RoleLayout';

/** Student menu: learn → see how I'm doing → school life → me. */
export const nav: NavItem[] = [
  { to: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, group: 'Overview' },

  { to: 'learn', label: 'Lessons & assignments', icon: BookOpen, group: 'Learning' },
  { to: 'live', label: 'Live classes', icon: Video, group: 'Learning' },
  { to: 'tests', label: 'Tests & exams', icon: Monitor, group: 'Learning' },
  { to: 'timetable', label: 'Timetable', icon: Clock, group: 'Learning' },
  { to: 'subjects', label: 'My subjects', icon: Library, group: 'Learning' },

  { to: 'results', label: 'My results', icon: Award, group: 'My progress' },
  { to: 'attendance', label: 'My attendance', icon: CheckSquare, group: 'My progress' },

  { to: 'calendar', label: 'Calendar & notices', icon: Calendar, group: 'School' },
  { to: 'uniform', label: 'Uniform', icon: Shirt, group: 'School' },

  { to: 'notifications', label: 'Notifications', icon: Bell, group: 'Me' },
  { to: 'account', label: 'Account', icon: UserCircle, group: 'Me' },
];
